import { Button, Modal } from 'react-bootstrap';
import React, { useContext, useEffect, useState } from 'react';
import config from "../config.json";
//import { Dropdown } from 'react-bootstrap';
import http from "../Services/httpService";
import AsyncSelect from 'react-select/async';
//import Select, { ActionMeta, OnChangeValue, Options, components, ControlProps, OptionProps, Props, StylesConfig } from 'react-select'
import { components } from 'react-select'

import { MainContext } from "../store/mainContext";
//import http from "../Services/httpService";
import noronServices from "../Services/noronServices";
import { toast } from "react-toastify";
import './AddDeviceUser.css'

export default function AddDeviceUser({ handleClose, show }) {
    const { changed, doChanged } = useContext(MainContext);
    const [isPosting, setIsPosting] = useState(false);
    const [showIng, setShowIng] = useState(false);
    const [form, setForm] = useState({})

    const handleCloseIng = () => {
        setShowIng(false);
        handleClose();
    }


    useEffect(() => {
        setShowIng(show);
        setForm(
            {
                Ime: "",
                SimNumber: "",
                CarName: "",
                ModeDevice: "0",
                icon: "",
            });
    }, [show])


    const handlePosting = async (e) => {
        e.preventDefault();
        if (form.Ime.length < 15) {
            toast.error('شماره ime صحیح وارد نشده است', { theme: "colored" });
            return;
        }
        setIsPosting(true);
        await noronServices.AddDeviceUser(form)
            .then(({ data }) => {
                setIsPosting(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return;
                }
                doChanged(!changed);
                handleCloseIng();
            })
            .catch(err => {
                setIsPosting(false);
            });
    }

    const [customerChoice, setCustomerChoice] = useState();
    const [typingTimeout, setTypingTimeout] = useState(setTimeout(() => { }, 3000));
    const loadOptions = (inputValue, callback) => {
        if (typingTimeout) {
            clearTimeout(typingTimeout);
        }
        let temp = setTimeout(() => {
            noronServices.PicCarList(
                {
                    from: 0,
                    pageSize: 100,
                    filters: {
                        GroupOp: "",
                        Groups:
                            [{
                                groupOp: "and",
                                rules: inputValue == "" ? [] : [{ op: "cn", field: "name", data: `\"${inputValue}\"` },]
                            }]
                    }, where: ""
                    , order: ""
                }
                /*{
                from: 0,
                pageSize: 100,
                where: inputValue == "" ? "" : `name.Contains("${inputValue}")`,
                order: "",
            }*/
            )
                .then(({ data }) => {
                    callback(data.payload.list.map((item, index) => {
                        return { index: index, value: item.name, ...item };
                        /*return {
                            index: index,
                            name: item.name,
                            value: item.name,
                            label2: item.name,
                            tel: item.tel,
                            mobile: item.mobile,
                            email: item.email,
                        }*/
                    }));
                })
                .catch(err => {
                });

        }, 700);
        setTypingTimeout(temp);
    }

    const formatOptionCustomerViewList = (data) => (
        <div className='row d-flex' style={{}}>
            <div className='col-auto '>
                <img src={`${config.apiUrl}/piccar/car${data.id}.png`} style={{ width: 40 }} />
            </div>
            <div className='col'>
                {data.name}
            </div>
        </div>
    );
    const Option = (props) => {
        return (
            <components.Option {...props} >
                <div className={`row rowOption`}>
                    <div className='col-auto'>
                        <img src={`${config.apiUrl}/piccar/car${props.data.id}.png`} className="picCar" />
                    </div>
                    <div className='col'>
                        {props.data.name}
                    </div>
                </div>
            </components.Option>
        );
    };

    const Control = ({ children, ...props }) => {
        return (
            <components.Control {...props}>
                {children}
            </components.Control>
        );
    };
    return (
        <>
            <Modal show={showIng} onHide={handleCloseIng} id="modalPatient">
                <Modal.Header closeButton>
                    <Modal.Title className="colorRed">ردیاب جدید</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container">
                        <div className="form-floating mb-3">
                            <input asp-for="Ime"
                                type="number"
                                name="Ime"
                                value={form.Ime}
                                onChange={e => http.handleChange(e, form, setForm)}
                                className="form-control" placeholder="شماره Ime" autoComplete="off" />
                            <label asp-for="Ime">شماره Ime ردیاب</label>
                            <span asp-validation-for="Ime" className="text-danger"></span>
                        </div>
                        <div className="form-floating mb-3">
                            <input asp-for="SimNumber"
                                type="number"
                                name="SimNumber"
                                value={form.SimNumber}
                                onChange={e => http.handleChange(e, form, setForm)}
                                className="form-control" placeholder="شماره سیم کارت درون ردیاب" autoComplete="off" />
                            <label asp-for="SimNumber">شماره سیم کارت درون ردیاب</label>
                            <span asp-validation-for="SimNumber" className="text-danger"></span>
                        </div>

                        <div className="form-floating mb-3">
                            <input asp-for="SimNumber"
                                type="text"
                                name="CarName"
                                value={form.CarName}
                                onChange={e => http.handleChange(e, form, setForm)}
                                className="form-control" placeholder="نام خودرو" autoComplete="off" />
                            <label asp-for="CarName">نام خودرو</label>
                            <span asp-validation-for="CarName" className="text-danger"></span>
                        </div>
                        {/*
                        <div className="form-floating mb-3">
                            <Dropdown
                                drop="down"
                                onSelect={eventKey => { setForm({ ...form, icon: eventKey }); }}
                            >
                                <Dropdown.Toggle className="form-control" id="dropdown-custom-components">
                                    {form.icon != "" &&
                                        <img src={`/images/${form.icon}`} className="navbarIcon" />}تصویر خودرو
                                    {form.icon == "" && <>
                                        <img src="/images/car1.png" className="navbarIcon" /></>}
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="form-control dropdownMenuCustom">
                                    {Array(24).fill().map((item, i) => (
                                        <Dropdown.Item key={"drop" + i + 1} eventKey={`car${i + 1}.png`}>
                                            <img src={`/images/car${i + 1}.png`} className="dropDownImageItem" />
                                        </Dropdown.Item>))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                                    */}
                        <AsyncSelect
                            className="  flex-fill mb-3"
                            styles={{
                                menu: provided => ({ ...provided, zIndex: 9999 }),
                                option: (provided, state) => {
                                    return {
                                        ...provided,
                                        // color: "blue",
                                        // backgroundColor: state.data === state.selectProps.value ? "red" : "white"
                                    };
                                }
                            }}
                            placeholder={'تصویر خودرو و انتخاب بفرمایید'}
                            //isLoading={isLoadingExternally}
                            value={customerChoice}
                            cacheOptions
                            loadOptions={loadOptions}
                            defaultOptions//={{id:1,name:"ddd"}}
                            formatOptionLabel={formatOptionCustomerViewList}
                            onChange={/*handleChangeSelect(newValue);*/
                                (newValue, actionMeta) => {
                                    setCustomerChoice(newValue);
                                    setForm({ ...form, icon: `car${newValue.id}.png` });
                                    console.log(newValue);
                                }
                            }
                            components={{
                                //   Control: Control,
                                Option: Option
                            }}
                        //isRtl
                        // isClearable                                                   
                        //isSearchable
                        //closeMenuOnSelect={false}
                        //closeMenuOnSelect={false}
                        //isMulti
                        //onInputChange={handleInputChange}
                        />
                        <div className="form-floating mb-3">
                            <select asp-for="SimNumber"
                                name="ModeDevice"
                                value={form.ModeDevice}
                                onChange={e => http.handleChange(e, form, setForm)}
                                className="form-select" placeholder="نوع ردیاب" autoComplete="off" >
                                <option value="5">m250</option>
                                <option value="0">S300</option>
                                <option value="3">S350</option>
                                <option value="1">S400</option>
                                <option value="2">S500</option>
                                <option value="4">S600</option>
                            </select>
                            <label asp-for="ModeDevice">نوع ردیاب</label>
                            <span asp-validation-for="ModeDevice" className="text-danger"></span>
                        </div>

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" className="col btn btn-success btn-block  myCustomButton"
                        onClick={handlePosting}
                        disabled={isPosting}>
                        <span>&nbsp;&nbsp;&nbsp;تایید
                            {isPosting &&
                                <div className="spinner-border spinner-border-sm" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>}
                        </span>
                    </Button>
                    <Button variant="danger" className="col btn btn-danger myCustomButton" data-bs-dismiss="modal"
                        onClick={handleClose}>
                        <span>&nbsp;&nbsp;&nbsp;انصراف</span>
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}